import React from "react";
import { YearPickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';

const PickerYear = ({
    stateDate = new Date(),
    fnSetDate,
    stateLabel = '',
    statePlaceHolder = '',
    stateFormat = "YYYY",
    stateClearable = false,
    stateDisabled = false,
    stateWithAsterisk = false,
    stateDescription = '',
    stateError = '',
    stateVariant = 'default', /* default | filled | unstyled */
    stateRadius = 'sm',
    stateSize = 'sm',
    stateIcon = <IconCalendar size="1.25rem" stroke={1.5} />,
    stateSX = {}
}) => {
    return (
        <YearPickerInput
            icon={stateIcon}
            label={stateLabel}
            placeholder={statePlaceHolder}
            value={stateDate}
            onChange={fnSetDate}
            valueFormat={stateFormat}
            clearable={stateClearable}
            disabled={stateDisabled}
            withAsterisk={stateWithAsterisk}
            description={stateDescription}
            error={stateError}
            variant={stateVariant}
            radius={stateRadius}
            size={stateSize}
            sx={stateSX}
        />
    )
}

export default PickerYear;